import TextField from '@material-ui/core/TextField';
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import React, { Component } from 'react';

const filter = createFilterOptions();
/**
   * Autocomplete
   * @param getOptions async () 
   * @param onChange function
   * @param {String} createLabel
   * @param {boolean} disabled - optional, default false
   */
class MyMultiSelectAutocomplete extends Component {
    state = {
        loading: false,
        open: false,
        options: [],
        value: "",
    }

    onOpen = () => {
        this.setState({ open: true });
        this.props.getOptions()
            .then(res => {
                if (res.length === 0) {
                    res.push({ label: "Nincs Találat", value: "notavalidoption" })

                }
                this.setState({ loading: false, options: res })
            });
    }

    filterOptions = (options, params) => {
        const filtered = filter(options, params);
        // Suggest the creation of a new value
        if (this.props.createLabel && filtered.length === 0 && params.inputValue !== '') {
            filtered.push({
                inputValue: params.inputValue,
                label: `${this.props.createLabel}: ${params.inputValue}`,
            });
        }
        return filtered;
    }

    getOptionSelected = (option, value) => {
        return option.label === value.label
    }

    getOptionLabel = (option) => {
        if (option && option.label) {
            return option.label
        } else {
            return "";
        }
    }

    isDisabled = () => {
        if (this.props.disabled) {
            return this.props.disabled;
        } else {
            return false;
        }
    }

    canShow = () => {
        console.log(this.props.hidden);
        if (this.props.hidden && this.props.hidden === true) {
            return false;
        } else {
            return true;
        }
    }

    getRenderOption = (option, { selected }) => {
        //console.log(this.props.renderOption)
        if (this.props.renderOption && "notavalidoption" !== option.value) {
            return this.props.renderOption(option, { selected });
        } else {
            return <>{option.label}</>
        }
    }

    render() {
        return (
            <>
                {!(this.props.hidden && this.props.hidden === true) ?
                    <Autocomplete
                        freeSolo
                        multiple
                        filterSelectedOptions
                        clearOnBlur
                        getOptionDisabled={(option) => option.value === "notavalidoption"}
                        name={this.props.name}
                        value={this.props.value}
                        autoComplete={true}
                        autoHighlight={true}
                        fullWidth
                        loading={this.state.loading}
                        onChange={this.props.onChange}
                        options={this.state.options}
                        getOptionSelected={this.getOptionSelected}
                        getOptionLabel={this.getOptionLabel}
                        filterOptions={this.filterOptions}
                        onOpen={this.onOpen}
                        onClose={() => this.setState({ open: false })}
                        disabled={this.isDisabled()}
                        noOptionsText="Nincs találat"
                        renderOption={this.getRenderOption}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={this.props.label}
                                variant="outlined"
                                InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                        <React.Fragment>
                                            {params.InputProps.endAdornment}
                                        </React.Fragment>
                                    ),
                                }}
                            />
                        )}
                    />
                    : <></>}
            </>
        );
    }
} export default MyMultiSelectAutocomplete